import { render, staticRenderFns } from "./PortalSession.vue?vue&type=template&id=1c585ab2&scoped=true"
import script from "./PortalSession.vue?vue&type=script&lang=js"
export * from "./PortalSession.vue?vue&type=script&lang=js"
import style0 from "./PortalSession.vue?vue&type=style&index=0&id=1c585ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c585ab2",
  null
  
)

export default component.exports